/* eslint-env browser, es6 */
import m from "mithril";

import { ApiError, Duel } from "../api";
import { KEY_SPACEBAR } from "../constants";
import { GameStateNotStarted } from "../game-state";
import { GameController } from "../game-controller";
import { ApiErrorView } from "./api-error";
import { EmptyBoardView } from "./board";
import { ButtonView } from "./button";
import { DuelDialogView } from "./duel-dialog";
import { FooterView, HeaderView } from "./header-footer";
import { InputView } from "./input";

interface GameNotStartedViewAttrs {
  state: GameStateNotStarted;
}

export class GameNotStartedView
  implements m.Component<GameNotStartedViewAttrs>
{
  private state: GameStateNotStarted;

  constructor(vnode: m.Vnode<GameNotStartedViewAttrs>) {
    this.state = vnode.attrs.state;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === KEY_SPACEBAR) {
      GameController.startGame();

      // Prevent space bar from scrolling page.
      event.preventDefault();
      m.redraw();
    }
  }

  onApiError(error: ApiError): void {
    this.state.error = error;
  }

  onDuelDialogFinish(duel: Duel): void {
    GameController.startDuel(duel, duel.creatorNickname);
  }

  oncreate(): void {
    document.addEventListener("keydown", this.onKeyDown);
  }

  onremove(): void {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  view(): m.Children {
    return [
      m(HeaderView),
      this.state.duelNotFound ? m("p", "Duel not found") : null,
      this.state.error ? m(ApiErrorView, { error: this.state.error }) : null,
      m(InputView, { disabled: true }),
      m(EmptyBoardView),
      this.state.startingDuel
        ? m(DuelDialogView, {
            hookOnError: (error: ApiError) => this.onApiError(error),
            hookOnFinish: (duel: Duel) => this.onDuelDialogFinish(duel),
          })
        : [
            m(ButtonView, {
              message: "Play",
              hookOnClick: GameController.startGame,
            }),
            m("p.btn-msg", "Play solo"),
            m(ButtonView, {
              message: "Duel",
              hookOnClick: () => {
                this.state.startingDuel = true;
              },
            }),
            m("p.btn-msg", "Challenge up to 5 friends"),
          ],
      m(FooterView),
    ];
  }
}
